import { render, staticRenderFns } from "./New_together.vue?vue&type=template&id=16954d42&scoped=true"
import script from "./New_together.vue?vue&type=script&lang=js"
export * from "./New_together.vue?vue&type=script&lang=js"
import style0 from "./New_together.vue?vue&type=style&index=0&id=16954d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16954d42",
  null
  
)

export default component.exports